module.exports = __webpack_public_path__ + "static/media/dice-four.5f7e3e63.svg";